const STATUS_TAG_TYPE = {
    // aqua
    AQUA: 'aqua',
    // red
    ERROR: 'error',
    // gray
    GRAY: 'gray',
    // light blue with dark text
    INFO: 'INFO',
    // orange
    ORANGE: 'orange',
    // purple
    PURPLE: 'purple',
    // green
    SUCCESS: 'success',
    // dark gray
    TRANSPARENT: 'transparent',
    // yellow
    WARNING: 'warning',
};

// map for property details status response
const LISTING_SUMMARY = {
    inactive: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    publishing: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    published: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    partiallypublished: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    declined: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// map for property details overview status response
const PROPERTY_DETAILS_OVERVIEW = {
    'off-market': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.TRANSPARENT,
    },
    'listed for rent': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.PURPLE,
    },
    'occupied by tenants': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.TRANSPARENT,
    },
};

// map for leases summary status response
const LEASE_SUMMARY = {
    active: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    expired: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    'incomplete draft': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    'complete draft': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    'signing canceled': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.PURPLE,
    },
    'signing complete': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    'signing in progress': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.AQUA,
    },
    'signing offline': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.AQUA,
    },
    'awaiting your signature': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// map for payment summary status response
const PAYMENT_SUMMARY = {
    info: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    neutral: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    in_progress: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    success: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    warn: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    caution: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// map for interested renders status response
const INTERESTED_RENTERS = {
    accepted: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    withdrawn: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    completed: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    pending: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARN,
    },
    invited: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.NEUTRAL,
    },
    received: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    'in-progress': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    'invited to apply': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
};

const STATUS_KEY = {
    INTERESTED_RENTERS: 'INTERESTED_RENTERS',
    LEASE_SUMMARY: 'LEASE_SUMMARY',
    LISTING_SUMMARY: 'LISTING_SUMMARY',
    PAYMENT_SUMMARY: 'PAYMENT_SUMMARY',
    PROPERTY_DETAILS_OVERVIEW: 'PROPERTY_DETAILS_OVERVIEW',
};

const LOOKUP = {
    [STATUS_KEY.INTERESTED_RENTERS]: INTERESTED_RENTERS,
    [STATUS_KEY.LEASE_SUMMARY]: LEASE_SUMMARY,
    [STATUS_KEY.LISTING_SUMMARY]: LISTING_SUMMARY,
    [STATUS_KEY.PAYMENT_SUMMARY]: PAYMENT_SUMMARY,
    [STATUS_KEY.PROPERTY_DETAILS_OVERVIEW]: PROPERTY_DETAILS_OVERVIEW,
};

const getTagTypeByKey = (key, status) => {
    try {
        // validation
        if (!key) {
            throw new Error('key is not defined', key);
        }

        if (!status) {
            throw new Error('status is not defined', status);
        }

        // do lookup
        return LOOKUP[key][status.toLowerCase()].STATUS_TAG_TYPE;
    } catch (error) {
        // handle error
        console.error(error);
        console.error(`A default value of "${STATUS_TAG_TYPE.GRAY}" is being returned. Check status %s`, status);

        // a type is required by the StatusTag component
        return STATUS_TAG_TYPE.GRAY;
    }
};

export {
    getTagTypeByKey,
    STATUS_KEY,
};
